module.exports = __webpack_public_path__ + "static/Spring-Langsdorf-800x500-19c03dacefcd291a774b18e9ec1bd7b5.jpg";